import { render } from "./App.vue?vue&type=template&id=23e68e38"
const script = {}

import "./App.vue?vue&type=style&index=0&id=23e68e38&lang=css"
script.render = render

export default script